import {mxConstants, mxStylesheet} from "mxgraph-js";

class FaultTreeManagementMxStylesheet extends mxStylesheet {
  getDefaultVertexStyle(): any {
    const style = super.getDefaultVertexStyle();
    style[mxConstants.STYLE_SHAPE] = mxConstants.SHAPE_RECTANGLE;
    style[mxConstants.STYLE_SPACING] = 12;
    style[mxConstants.STYLE_FILLCOLOR] = 'rgba(17,0,255,0.11)';
    style[mxConstants.STYLE_STROKECOLOR] = 'rgba(135,140,255,0.62)';
    style[mxConstants.STYLE_FILL_OPACITY] = '100';
    style[mxConstants.STYLE_STROKE_OPACITY] = '100';
    style[mxConstants.STYLE_STROKEWIDTH] = '2';
    style[mxConstants.STYLE_FONTCOLOR] = 'inherit';
    style[mxConstants.STYLE_FONTSIZE] = '14';
    style[mxConstants.STYLE_FONTFAMILY] = 'Roboto Condensed';
    style[mxConstants.STYLE_WHITE_SPACE] = 'wrap';
    style[mxConstants.STYLE_AUTOSIZE] = 1;
    style[mxConstants.STYLE_RESIZABLE] = 0;
    style[mxConstants.STYLE_OVERFLOW] = 'width';
    return style;
  }

  getDefaultEdgeStyle(): any {
    const edgeStyle = super.getDefaultEdgeStyle();
    edgeStyle[mxConstants.STYLE_STROKECOLOR] = '#343763';
    edgeStyle[mxConstants.STYLE_STROKEWIDTH] = '1.5';
    return edgeStyle;
  }
}

export default FaultTreeManagementMxStylesheet;
